import api from './api';

const unwrap = (res, fallback) => {
  if (res && res.success === true) return { success: true, data: res.data };
  return { success: false, error: (res && (res.message || res.error)) || fallback };
};

class EmailTemplateService {
  async listTemplates(params = {}) {
    try {
      const res = await api.get('/admin/email-templates', params);
      return unwrap(res, 'Failed to list templates');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to list templates' };
    }
  }

  async getTemplate(id) {
    try {
      const res = await api.get(`/admin/email-templates/${id}`);
      return unwrap(res, 'Failed to fetch template');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to fetch template' };
    }
  }

  async createTemplate(payload) {
    try {
      const res = await api.post('/admin/email-templates', payload);
      return unwrap(res, 'Failed to create template');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to create template' };
    }
  }

  async updateTemplate(id, payload) {
    try {
      const res = await api.put(`/admin/email-templates/${id}`, payload);
      return unwrap(res, 'Failed to update template');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to update template' };
    }
  }

  async deleteTemplate(id) {
    try {
      const res = await api.delete(`/admin/email-templates/${id}`);
      return unwrap(res, 'Failed to delete template');
    } catch (e) {
      return { success: false, error: e.message || 'Failed to delete template' };
    }
  }
}

export default new EmailTemplateService();
